module.exports = __webpack_public_path__ + "static/cabina-conductor---grada-de-ingreso-489db23467819b5b5824b6119aed31f3.jpg";